__turbopack_context__.v({
  "hero": "hero-module__HNXeQG__hero",
  "heroContent": "hero-module__HNXeQG__heroContent",
  "heroCountdown": "hero-module__HNXeQG__heroCountdown",
  "heroFooter": "hero-module__HNXeQG__heroFooter",
  "heroImage": "hero-module__HNXeQG__heroImage",
  "heroImageGradient": "hero-module__HNXeQG__heroImageGradient",
  "heroSubtitle": "hero-module__HNXeQG__heroSubtitle",
  "heroTitle": "hero-module__HNXeQG__heroTitle",
  "heroTrustpilot": "hero-module__HNXeQG__heroTrustpilot",
  "makeATree": "hero-module__HNXeQG__makeATree",
  "subCTA": "hero-module__HNXeQG__subCTA",
  "treeAndTrust": "hero-module__HNXeQG__treeAndTrust",
  "treeDivider": "hero-module__HNXeQG__treeDivider",
  "trustpilotScore": "hero-module__HNXeQG__trustpilotScore",
  "wave": "hero-module__HNXeQG__wave",
  "waveWrapper": "hero-module__HNXeQG__waveWrapper",
});
